import React, { useEffect, useMemo, useState } from 'react';
import CustomTable from '../../share-components/CustomTable';
import { Link, useNavigate } from 'react-router-dom';
import { PAGE_INSTOCK_LIST, ROUTE_INSTOCK_LIST, ROUTE_PRODUCT_CREATE, ROUTE_PRODUCT_DETAILS, ROUTE_PRODUCT_EDIT, ROUTE_PRODUCT_LIST } from '../../constants/routeConstants';
import { Accordion, Button, Card, Container } from 'react-bootstrap';
import { useAppContext } from '../../share-components/AppContext';
import { getActiveCategories } from '../../services/ManagementService';
import NoDataFound from '../../share-components/NoDataFound';
import useScrollRestoration from '../../share-components/UseScrollRestoration';
import SearchColumnSelect from '../../share-components/SearchColumnSelect';
import FormTitle from '../../share-components/FormTitle';
import {
    currentMonth, currentYear, customStorage, formatDateTime, getAvailableMonths, getChangingSelectColor, getPayloadData, handleFromMonthChange,
    handleFromYearChange, handleToMonthChange, handleToYearChange, isInRole, isNullOrEmptyString, years
} from '../../services/UtilityService';
import FloatingCartButton from '../../share-components/FloatingCartButton';
import noImage from '../../assets/No_Image_Available.jpg';
import { SELECT_ALL_DEFAULT, SELECT_DEFAULT, SERVER_ERROR_MESSAGE, TBL_DATA_SEPARATOR, TOKEN_SESSION_KEY } from '../../constants/commonConstants';
import { getAllActiveUsers } from '../../services/CommonService';
import CommonDialog from '../../share-components/CommonDialog';
import ProductInfoShare from '../../share-components/ProductInfoShare';
import AlertDialog from '../../share-components/AlertDialog';
import { editAdjustComment, getInstockProducts, sendItemToOther, toggleStockAdjustedFlag } from '../../services/InstockAdjustmentService';
import ConfirmDialog from '../../share-components/ConfirmDialog';
import { RG_ADMIN_ONLY } from '../../constants/roleConstants';

const InstockAdjustmentList = () => {

    useScrollRestoration(PAGE_INSTOCK_LIST);

    const initialSearchDataObj = sessionStorage.getItem(ROUTE_INSTOCK_LIST);
    const initialSearchData = initialSearchDataObj ? JSON.parse(initialSearchDataObj) : null;

    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);

    const { loading, setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const [instockProductList, setInstockProductList] = useState([]);
    const [instockProductListTableData, setInstockProductListTableData] = useState([]);

    const [userById, setUserById] = useState(initialSearchData?.userById || "");
    const [categoryId, setCategoryId] = useState(initialSearchData?.categoryId || "");
    const [stockAdjustedFlag, setStockAdjustedFlag] = useState(initialSearchData?.stockAdjustedFlag || "");
    const [categories, setCategories] = useState([]);
    const [activeUsers, setActiveUsers] = useState([]);
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);

    const [targetToggleAdjustProduct, setTargetToggleAdjustProduct] = useState(null);

    const [showSendItemFormDialog, setShowSendItemFormDialog] = useState(false);
    const [showEditAdjustCommentFormDialog, setShowEditAdjustCommentFormDialog] = useState(false);
    const [showClearAdjustCommentConfirmDialog, setShowClearAdjustCommentConfirmDialog] = useState(false);
    const [selectedItemInfo, setSelectedItemInfo] = useState({});

    const [sendItemCount, setSendItemCount] = useState("");
    const [sendToUserId, setSendToUserId] = useState("");
    const [newAdjustComment, setNewAdjustComment] = useState("");
    const [successDialogMessage, setSuccessDialogMessage] = useState(null);

    const [filteredData, setFilteredData] = useState([]);

    const [summaryInfo, setSummaryInfo] = useState({});

    const [openInstockAccordions, setOpenInstockAccordions] = useState({});
    const [openOutOfStockAccordions, setOpenOutOfStockAccordions] = useState({});
    const [openAdjustComment, setOpenAdjustComment] = useState({});

    const [searchData, setSearchData] = useState(null);
    const [afterGetDataStore, setAfterGetDataStore] = useState({
        userById: initialSearchData?.userById || "",
        categoryId: initialSearchData?.categoryId || "",
        stockAdjustedFlag: initialSearchData?.stockAdjustedFlag || ""
    });

    const navigate = useNavigate();

    useEffect(() => {
        const searchData = {
            userById,
            categoryId,
            stockAdjustedFlag
        };
        setSearchData(searchData);
    }, [loading]);

    const fetchInitialLoad = async () => {
        try {
            setLoading(true);
            const response = await getAllActiveUsers();
            const sortedUsers = (response || [])?.sort((a, b) => (a.username || "")?.localeCompare((b?.username || "")));
            setActiveUsers(sortedUsers);
            const categoryList = await getActiveCategories();
            let sortedCategories = (categoryList || [])?.sort((a, b) => (a.categoryName || "")?.localeCompare((b?.categoryName || "")));
            setCategories(sortedCategories);
            await fetchInstockProducts();
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const fetchInstockProducts = async () => {
        setLoading(true);
        const catIdNumber = parseInt(categoryId, 10) || 0;
        const stockAdjustedFlagNumber = parseInt(stockAdjustedFlag, 10);
        try {
            const formData = {
                userById: userById || null,
                categoryId: catIdNumber > 0 ? catIdNumber : null,
                stockAdjustedFlag: stockAdjustedFlagNumber === 0 ? false : stockAdjustedFlagNumber === 1 ? true : null,
            }
            const response = await getInstockProducts(formData);
            const result = response.result || [];
            const idList = result.map(p => Number(p.productId));
            setOpenInstockAccordions(prev => filterAccordionState(prev, idList));
            setOpenOutOfStockAccordions(prev => filterAccordionState(prev, idList));
            setOpenAdjustComment(prev => filterAccordionState(prev, idList));
            setInstockProductList(result);

            const afterGetData = {
                userById,
                categoryId,
                stockAdjustedFlag
            }
            setAfterGetDataStore(afterGetData);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const filterAccordionState = (prev, idList) => {
        return Object.fromEntries(
            Object.entries(prev).map(([key, value]) => [
                key,
                idList.includes(Number(key)) ? value : null,
            ])
        );
    };


    useEffect(() => {
        setRouteNaviData("STOCK >> STOCK LIST");
        fetchInitialLoad();
    }, []);

    useEffect(() => {
        const convertedResponse = (instockProductList || []).map((pData) => ({
            ...pData,
            showData: getShowData(pData)
        }));
        setInstockProductListTableData(convertedResponse);
    }, [instockProductList, openInstockAccordions, openOutOfStockAccordions, openAdjustComment]);

    const getShowData = (productData) => {

        const brandName = productData?.brandName || "";
        const productName = productData?.productName || "";
        const categoryName = productData?.categoryName || "";
        const isColorSizeExist = productData.colorCount > 0 || productData.sizeCount > 0;
        const colorCount = productData?.colorCount || 0;
        const colorText = `[${colorCount} Color${colorCount > 1 ? 's' : ''}]`;
        const sizeCount = productData?.sizeCount || 0;
        const sizeText = `[${sizeCount} Size${sizeCount > 1 ? 's' : ''}]`;
        const productPicture = productData?.productPicture;
        const totalProductInstockQuantity = parseInt(productData?.totalProductInstockQuantity, 10) || 0;
        const totalProductOutOfStockQuantity = parseInt(productData?.totalProductOutOfStockQuantity, 10) || 0;
        const lastStockAdjustedFlagChangeUserShow = productData?.stockAdjustedFlagChangedByUser ? ` (By: ${productData?.stockAdjustedFlagChangedByUser})` : "";
        const stockAdjustedFlagShow = productData?.stockAdjustedFlag ? `Adjusted${lastStockAdjustedFlagChangeUserShow}` : `Not Adjusted${lastStockAdjustedFlagChangeUserShow}`;

        const onlyProductInfo = {
            productName,
            brandName,
            categoryName,
            productPicture
        }

        const plainText = [
            brandName,
            productName,
            categoryName,
            isColorSizeExist ? `${colorCount > 0 ? colorText : ''} ${sizeCount > 0 ? sizeText : ''}` : "",
            `Adjust Comment(${productData?.adjustComment ? "あり" : "なし"})`,
            `InStock(${productData?.totalProductInstockQuantity})`,
            totalProductOutOfStockQuantity < 0 ? `OutOfStock(${productData?.totalProductInstockQuantity})` : "",
        ].filter(Boolean).join(TBL_DATA_SEPARATOR);

        return {
            jsx: (
                <div style={{ fontWeight: '600' }}>
                    <div style={{
                        display: 'flex',
                    }}>
                        <div style={{ paddingRight: '10px', flex: "1" }}>
                            <div><i className='bi bi-award'></i> {brandName}</div><hr className='m-0' />
                            <div><i className='bi bi-box'></i> {productName}</div><hr className='m-0' />
                            <div><i className='bi bi-tags'></i> {categoryName}</div><hr className='m-0' />
                            {isColorSizeExist &&
                                <div>
                                    <i className='bi bi-palette'></i>
                                    {colorCount > 0 && <span> {colorText}</span>}
                                    {sizeCount > 0 && <span> {sizeText}</span>}
                                </div>
                            }
                            <div
                                style={{
                                    color: `${productData?.stockAdjustedFlag ? 'blue' : 'red'}`
                                }}
                            ><i className='bi bi-list-check'></i> {stockAdjustedFlagShow}</div><hr className='m-0' />
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                            <img
                                src={productPicture ? `data:image/jpeg;base64,${productPicture}` : noImage}
                                alt="picture"
                                className="img-thumbnail"
                                style={{ width: "var(--orderProductPictureWidth)", height: "var(--orderProductPictureHeight)", objectFit: "cover" }}
                            />
                        </div>
                    </div>

                    <div className='stockAccordion no-pad mb-1'>
                        <Accordion
                            activeKey={openAdjustComment[productData.productId] || null}
                            onSelect={(key) => {
                                setOpenAdjustComment((prev) => ({
                                    ...prev,
                                    [productData.productId]: prev[productData.productId] === key ? null : key
                                }));
                            }}
                        >
                            <Accordion.Item eventKey="0" >
                                <Accordion.Header>
                                    <div>
                                        <i className='bi bi-chat-dots'></i> Adjust Comment({productData?.adjustComment ? "あり" : "なし"})
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='p-2' style={{fontSize: "0.9rem"}}>
                                        {productData?.adjustCommentBy &&
                                            <div style={{ display: "block" }}>
                                                Last UpdatedBy: {productData?.adjustCommentBy}
                                            </div>}
                                        {productData?.adjustComment && <div style={{
                                            border: "1px solid",
                                            padding: "5px",
                                            borderRadius: "5px",
                                        }}>
                                            <div
                                                style={{
                                                    whiteSpace: "pre-wrap",   // keeps line breaks + wraps long lines
                                                    wordBreak: "break-word",  // breaks long words
                                                    padding: "8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "5px",
                                                    minHeight: "80px",
                                                    fontSize: "14px",
                                                    background: "#fafafa"
                                                }}
                                            >
                                                {productData?.adjustComment}
                                            </div>
                                            {/* {productData?.adjustComment} */}
                                        </div>}
                                        {isInRole(RG_ADMIN_ONLY, currentUser?.role) && <div style={{
                                            display: "flex",
                                            justifyContent: "start",
                                            gap: "20px",
                                            alignItems: "start",
                                            marginTop: "10px",
                                            flexWrap: "wrap"
                                        }}>
                                            <button type='button' className='btn btn-outline-success btn-sm appBtn'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onEditCommentClick(onlyProductInfo, productData?.productId, productData?.adjustComment)
                                                }}
                                            >
                                                {productData?.adjustComment ? "Edit Comment" : "Add Comment"}
                                            </button>
                                            <button type='button' className='btn btn-outline-success btn-sm appBtn'
                                                disabled={!productData?.adjustComment}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onClearAdjustComment(productData?.productId, productData?.adjustComment)
                                                }}
                                            >
                                                Clear Comment
                                            </button>
                                        </div>}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <hr className='m-0' />
                    </div>

                    <div className='stockAccordion'>
                        <Accordion
                            activeKey={openInstockAccordions[productData.productId] || null}
                            onSelect={(key) => {
                                setOpenInstockAccordions((prev) => ({
                                    ...prev,
                                    [productData.productId]: prev[productData.productId] === key ? null : key
                                }));
                            }}
                        >
                            <Accordion.Item eventKey="instock">
                                <Accordion.Header>
                                    <div>
                                        <i className='bi bi-bag-check'></i> InStock({totalProductInstockQuantity})
                                    </div>
                                </Accordion.Header>

                                <Accordion.Body>
                                    <div className='stockAndInStockDetailsBlock'
                                        style={{
                                            maxWidth: '100%'
                                        }}
                                    >
                                        {productData?.userStockInfo?.map((userInfo, index) => {

                                            if (userInfo?.stockInfo?.length <= 0) return;

                                            return (
                                                <div key={index}
                                                    style={{
                                                        border: "1px solid black",
                                                        padding: "5px",
                                                        marginBottom: "5px",
                                                        borderRadius: "5px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            color: "blue",
                                                            marginBottom: "5px",
                                                            marginLeft: "15px"
                                                        }}
                                                    ><span
                                                        style={{
                                                            borderBottom: "2px solid black"
                                                        }}
                                                    >
                                                            {userInfo?.username}
                                                        </span>
                                                    </div>
                                                    <table className='table table-bordered table-striped mb-1'>
                                                        <tbody>
                                                            {userInfo?.stockInfo?.map((invItem, idx) => {
                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>
                                                                            <div className='my-1'>

                                                                                {invItem.color && <span>[{invItem.color}]</span>}
                                                                                {invItem.size && <span>[{invItem.size}]</span>}
                                                                                <span className='mx-1'>(x{invItem.instockQuantity})</span>
                                                                                {(!isNullOrEmptyString(userInfo.userById) && currentUser.userId === userInfo.userById) &&
                                                                                    <button type='button' className='btn btn-outline-success btn-sm appBtn'
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation(); // 👈 prevent accordion toggle
                                                                                            onSendClick(onlyProductInfo, invItem)
                                                                                        }}
                                                                                        disabled={invItem.instockQuantity <= 0}
                                                                                    >
                                                                                        Send to
                                                                                    </button>}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    {/* <hr className='m-0' /> */}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <hr className='m-0' />
                    </div>

                    {totalProductOutOfStockQuantity < 0 &&
                        <div className='stockAccordion'>
                            <Accordion
                                activeKey={openOutOfStockAccordions[productData.productId] || null}
                                onSelect={(key) => {
                                    setOpenOutOfStockAccordions((prev) => ({
                                        ...prev,
                                        [productData.productId]: prev[productData.productId] === key ? null : key
                                    }));
                                }}
                            >
                                <Accordion.Item eventKey="outofstock">
                                    <Accordion.Header>
                                        <div className='text-danger'>
                                            <i className='bi bi-bag-dash'></i> OutOfStock({totalProductOutOfStockQuantity})
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='stockAndInStockDetailsBlock'
                                            style={{
                                                maxWidth: '100%'
                                            }}
                                        >
                                            {productData?.userStockInfo?.map((userInfo, index) => {

                                                if (userInfo?.outOfStockInfo?.length <= 0) return;

                                                return (<div key={index}
                                                    style={{
                                                        border: "1px solid black",
                                                        padding: "5px",
                                                        marginBottom: "5px",
                                                        borderRadius: "5px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            color: "blue",
                                                            marginBottom: "5px",
                                                            marginLeft: "15px"
                                                        }}
                                                    ><span
                                                        style={{
                                                            borderBottom: "2px solid black"
                                                        }}
                                                    >
                                                            {userInfo?.username}
                                                        </span>
                                                    </div>
                                                    <table className='table table-bordered table-striped mb-1'>
                                                        <tbody>
                                                            {userInfo?.outOfStockInfo?.map((invItem, idx) => {
                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>
                                                                            <div className='my-1 text-danger'>

                                                                                {invItem.color && <span>[{invItem.color}]</span>}
                                                                                {invItem.size && <span>[{invItem.size}]</span>}
                                                                                <span className='mx-1'>(x{invItem.instockQuantity})</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    {/* <hr className='m-0' /> */}
                                                </div>
                                                )
                                            })}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            <hr className='m-0' />
                        </div>}
                </div>
            ),
            text: plainText.toLowerCase()
        };
    };

    const handleToggleStockAdjustedFlag = async () => {
        setLoading(true);
        const productId = parseInt(targetToggleAdjustProduct?.productId, 10) || 0;
        const stockAdjustedFlag = targetToggleAdjustProduct?.stockAdjustedFlag;
        setTargetToggleAdjustProduct(null);
        try {
            const formData = {
                productId,
                stockAdjustedFlag: !stockAdjustedFlag,
            }
            await toggleStockAdjustedFlag(formData);
            setSuccessDialogMessage("Adjusted status is successfully updated.");
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {
            Header: 'Instock Products',
            accessor: 'showData',
            disableSortBy: true,
            style: {
                minWidth: "150px",
                maxWidth: "350px",
            },
            Cell: ({ row }) => row.original.showData.jsx,
        },
        {
            Header: 'Adjust Status',
            accessor: 'adjustStatus',
            unSearchable: true,
            disableSortBy: true,
            headerClassName: 'disableSort text-center',
            className: 'text-center align-middle',
            style: {
                minWidth: "70px",
                // maxWidth: "100px"
            },
            Cell: ({ row }) => (
                <div className='center-block'>
                    <Button
                        variant={`${row.original?.stockAdjustedFlag ? 'dark' : 'success'}`}
                        className={`btn-sm icon-btn-vertical`}
                        onClick={() => setTargetToggleAdjustProduct(row.original)}
                        disabled={!isInRole(RG_ADMIN_ONLY, currentUser?.role)}
                    >
                        <i className={`bi ${row.original?.stockAdjustedFlag ? 'bi-x-circle' : 'bi-check-circle'}`}></i>
                        <span>{row.original?.stockAdjustedFlag ? 'Make Not Adjusted' : 'Make Adjusted'}</span>
                    </Button>
                </div>
            ),
        },
        {
            Header: 'Product Details',
            accessor: 'productDetails',
            unSearchable: true,
            disableSortBy: true,
            headerClassName: 'disableSort text-center',
            className: 'text-center align-middle',
            style: {
                minWidth: "70px",
                // maxWidth: "100px"
            },
            Cell: ({ row }) => (
                <div className='center-block'>
                    <Button
                        as={Link}
                        to={`${ROUTE_PRODUCT_DETAILS}/${row.original?.productId}`}
                        variant="secondary"
                        className="btn-sm icon-btn-vertical"
                    >
                        <i className="bi bi-info-circle"></i>
                        <span>Product Details</span>
                    </Button>
                </div>
            ),
        },
    ];

    const onSendClick = (productInfo, inventoryInfo) => {
        const selectedInfo = {
            ...productInfo,
            ...inventoryInfo
        }
        setSelectedItemInfo(selectedInfo);
        setShowSendItemFormDialog(true);
    }

    const onEditCommentClick = (productInfo, productId, oldAdjustComment) => {
        const selectedInfo = {
            ...productInfo,
            productId,
            oldAdjustComment,
        }
        setSelectedItemInfo(selectedInfo);
        setNewAdjustComment(oldAdjustComment);
        setShowEditAdjustCommentFormDialog(true);
    }

    const onClearAdjustComment = (productId, oldAdjustComment) => {
        const selectedInfo = {
            productId,
            oldAdjustComment,
        }
        setSelectedItemInfo(selectedInfo);
        setShowClearAdjustCommentConfirmDialog(true);
    }

    const resetForms = () => {
        setShowSendItemFormDialog(false);
        setShowEditAdjustCommentFormDialog(false);
        setShowClearAdjustCommentConfirmDialog(false);
        setSelectedItemInfo({});
        setSendItemCount("");
        setSendToUserId("");
        setNewAdjustComment("");
    }

    const handleSend = async () => {
        setLoading(true);
        const itemCountNumber = parseInt(sendItemCount, 10) || 0;
        const itemIdNumber = parseInt(selectedItemInfo?.inventoryItemId, 10) || 0;
        try {
            const formData = {
                sendFromUserId: currentUser?.userId || null,
                sendToUserId: sendToUserId || null,
                inventoryItemId: itemIdNumber > 0 ? itemIdNumber : null,
                sendItemCount: itemCountNumber > 0 ? itemCountNumber : null
            }
            await sendItemToOther(formData);
            resetForms();
            setSuccessDialogMessage(`Your stock is successfully sent to ${activeUsers.find(user => user.userId === sendToUserId)?.username || "Other"}.`);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleEditOrClearAdjustComment = async (isClear = false) => {
        setLoading(true);
        const productIdNumber = parseInt(selectedItemInfo?.productId, 10) || 0;
        try {
            const formData = {
                productId: productIdNumber,
                adjustComment: isClear ? null : newAdjustComment,
            }
            await editAdjustComment(formData);
            resetForms();
            setSuccessDialogMessage(`Adjust Comment is successfully ${isClear ? "cleared" : "updated"}.`);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSuccessDialogClose = async () => {
        setSuccessDialogMessage(null);
        await fetchInstockProducts();
    }

    const renderSendItemForm = (
        // <Container style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '30px' }}>
        <Card style={{ fontWeight: 'normal', width: '100%', maxWidth: "650px", padding: '5px', margin: '0 auto' }}>
            <Card.Body>
                <h5 className="text-center mb-4">Send Your Item(s) to Other</h5>
                <ProductInfoShare categoryName={selectedItemInfo?.categoryName} brandName={selectedItemInfo?.brandName}
                    productName={selectedItemInfo?.productName} productPicture={selectedItemInfo?.productPicture} />
                <div>
                    {(!isNullOrEmptyString(selectedItemInfo?.color) || !isNullOrEmptyString(selectedItemInfo?.size)) &&
                        <span>
                            <i className='bi bi-palette'></i>
                            {!isNullOrEmptyString(selectedItemInfo?.color) && <span> [{selectedItemInfo?.color}]</span>}
                            {!isNullOrEmptyString(selectedItemInfo?.size) && <span> [{selectedItemInfo?.size}]</span>}
                        </span>
                    }
                    <span> x({selectedItemInfo?.instockQuantity})</span>
                </div>
                <hr />

                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                    <div className="d-inline-block">
                        <label className="custom-label" htmlFor="itemCount" style={{ minWidth: "50px" }}>
                            Item Count
                        </label>
                        <div>
                            <select
                                id='itemCount'
                                className={`customInputControl select-min-max-width`}
                                style={{
                                    minWidth: '135px',
                                    maxWidth: '150px'
                                }}
                                value={sendItemCount}
                                onChange={(e) => setSendItemCount(e.target.value)}
                            >
                                <option value={""}>{SELECT_DEFAULT}</option>
                                {Array.from({ length: selectedItemInfo?.instockQuantity || 0 }, (_, i) => i + 1).map(count => (
                                    <option key={count} value={count}>
                                        {count}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="d-inline-block">
                        <label className="custom-label" htmlFor="sentToId" style={{ minWidth: "50px" }}>
                            Send to User
                        </label>
                        <div>
                            <select
                                id="sentToId"
                                className={`customInputControl select-min-max-width`}
                                style={{
                                    minWidth: '135px',
                                    maxWidth: '150px'
                                }}
                                value={sendToUserId}
                                onChange={(e) => setSendToUserId(e.target.value)}
                            >
                                <option value={""}>{SELECT_DEFAULT}</option>
                                {activeUsers.filter(usr => usr?.userId !== currentUser?.userId).map(activeUser => (
                                    <option key={activeUser?.userId} value={activeUser?.userId}>{activeUser?.username}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className='mt-2'>
                    <button type='button' className='btn btn-primary appBtn'
                        disabled={isNullOrEmptyString(sendItemCount) || isNullOrEmptyString(sendToUserId)}
                        onClick={handleSend}
                    >
                        Send
                    </button>
                </div>

            </Card.Body>
        </Card>
        // </Container>
    );

    const renderEditAdjustCommentForm = (
        <Card style={{ fontWeight: 'normal', width: '100%', maxWidth: "650px", padding: '5px', margin: '0 auto' }}>
            <Card.Body>
                <h5 className="text-center mb-4">{selectedItemInfo?.oldAdjustComment ? "Edit Adjust Comment" : "Add Adjust Comment"}</h5>
                <ProductInfoShare categoryName={selectedItemInfo?.categoryName} brandName={selectedItemInfo?.brandName}
                    productName={selectedItemInfo?.productName} productPicture={selectedItemInfo?.productPicture} />
                <hr />

                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                    <textarea
                        id="adjustComment-textarea"
                        value={newAdjustComment || ""}
                        onChange={e => setNewAdjustComment(e.target.value)}
                        placeholder={"Enter Adjust Comment"}
                        maxLength={1000}
                        rows={5}
                        style={{ width: "100%", padding: 8, fontSize: 14 }}
                    />
                </div>

                <div className='mt-2'>
                    <button type='button' className='btn btn-primary appBtn'
                        disabled={isNullOrEmptyString(newAdjustComment)}
                        onClick={(e) => handleEditOrClearAdjustComment(false)}
                    >
                        Save
                    </button>
                </div>

            </Card.Body>
        </Card>
        // </Container>
    );

    useEffect(() => {
        const listData = filteredData || [];
        const totalInstockQuantity = listData?.reduce((sum, item) => sum + item.totalProductInstockQuantity, 0);
        const totalOutOfStockQuantity = listData?.reduce((sum, item) => sum + item.totalProductOutOfStockQuantity, 0);
        const onlyMyInstockQuantity = listData.reduce((finalSum, item) => {
            const myStock = item.userStockInfo?.find(
                user => user.userById === currentUser.userId
            );
            return finalSum + (myStock?.totalInventoryInstockQuantity ?? 0);
        }, 0);

        const onlyMyOutOfStockQuantity = listData.reduce((finalSum, item) => {
            const myStock = item.userStockInfo?.find(
                user => user.userById === currentUser.userId
            );
            return finalSum + (myStock?.totalInventoryOutOfStockQuantity ?? 0);
        }, 0);
        const summary = {
            totalInstockQuantity,
            totalOutOfStockQuantity,
            onlyMyInstockQuantity,
            onlyMyOutOfStockQuantity
        }
        setSummaryInfo(summary);
    }, [filteredData]);


    return (
        <div id='instockAdjustmentPage'>
            <FormTitle title={"Stock List"} isCenter={true} />
            {isFirstLoaded && <>
                <div style={{ overflow: "auto", paddingBottom: "50px" }}>
                    <div style={{ minWidth: "max-content", maxWidth: "650px", margin: '0 auto' }}>
                        <Card>
                            <Card.Body style={{ padding: '10px 5px 20px 5px' }}>
                                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                    <div className="d-inline-block">
                                        <label className="custom-label" htmlFor="userById" style={{ minWidth: "50px" }}>
                                            User By
                                        </label>
                                        <div>
                                            <select
                                                id="userById"
                                                className={`customInputControl select-min-max-width ${getChangingSelectColor(userById, afterGetDataStore?.userById)}`}
                                                style={{
                                                    minWidth: '135px',
                                                    maxWidth: '150px'
                                                }}
                                                value={userById}
                                                onChange={(e) => setUserById(e.target.value)}
                                            >
                                                <option value={""}>{SELECT_ALL_DEFAULT}</option>
                                                {activeUsers.map(activeUser => (
                                                    <option key={activeUser.userId} value={activeUser.userId}>{activeUser.username}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="d-inline">
                                        <label className="me-1 custom-label" htmlFor="category" style={{ minWidth: "50px" }}>
                                            Category
                                        </label>
                                        <div>
                                            <select
                                                id="category"
                                                className={`customInputControl me-2 select-min-max-width ${getChangingSelectColor(categoryId, afterGetDataStore?.categoryId)}`}
                                                value={categoryId}
                                                onChange={(e) => setCategoryId(e.target.value || '')}
                                            >
                                                <option value="">{SELECT_ALL_DEFAULT}</option>
                                                {categories.map(category => (
                                                    <option key={category.categoryId} value={category.categoryId}>{category.categoryName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                    <div className="d-inline">
                                        <label className="me-1 custom-label" htmlFor="category" style={{ minWidth: "50px" }}>
                                            Adjusted Status
                                        </label>
                                        <div>
                                            <select
                                                id="adjustedStatus"
                                                className={`customInputControl me-2 select-min-max-width ${getChangingSelectColor(stockAdjustedFlag, afterGetDataStore?.stockAdjustedFlag)}`}
                                                value={stockAdjustedFlag}
                                                onChange={(e) => setStockAdjustedFlag(e.target.value || '')}
                                            >
                                                <option value="">{SELECT_ALL_DEFAULT}</option>
                                                <option value="1">Adjusted</option>
                                                <option value="0">Not Adjusted</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-inline">
                                    <Button type='button' variant='success' className="btn-sm appBtn"
                                        onClick={fetchInstockProducts}
                                    >Get Data</Button>
                                </div>

                                <div className='summaryAccordion mt-1'>
                                    <Accordion  >
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                <div style={{ minWidth: '258px' }}>
                                                    Summary Info
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                    <table className='table table-bordered auto-width-table'>
                                                        <tbody>
                                                            <tr><td>Total Instock Quantity:</td><td>{summaryInfo?.totalInstockQuantity}</td></tr>
                                                            <tr><td>Total OutOfStock Quantity:</td><td>{summaryInfo?.totalOutOfStockQuantity}</td></tr>
                                                            <tr><td>Only My Instock Quantity:</td><td>{summaryInfo?.onlyMyInstockQuantity}</td></tr>
                                                            <tr><td>Only My OutOfStock Quantity:</td><td>{summaryInfo?.onlyMyOutOfStockQuantity}</td></tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>

                                <div>
                                    <div style={{ marginBottom: '10px', marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'end', flexWrap: 'wrap', gap: '5px' }}>
                                        <SearchColumnSelect data={instockProductListTableData} setData={setFilteredData} columns={columns}
                                            isNoColumn={true} storeSessionKey={ROUTE_INSTOCK_LIST} sessionData={searchData}
                                        />
                                    </div>
                                    {filteredData?.length > 0 ?
                                        <CustomTable
                                            tableId='instockAdjustmentListTbl'
                                            columns={columns}
                                            tblData={filteredData || []}
                                            showPagination={(filteredData || []).length > 0}
                                            itemsPerPage={10}
                                            // initialSortBy={[{ id: 'showData', desc: false }]}
                                            noHeader={true}
                                            isStorePageData={true}
                                        /> :
                                        <NoDataFound />}
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </>}

            <CommonDialog
                dialogId='sendItemFormDialog'
                show={showSendItemFormDialog}
                noCloseBtn={false}
                onHide={resetForms}
                size={'lg'}
                body={renderSendItemForm}
            />

            <CommonDialog
                dialogId='editAdjustCommentFormDialog'
                show={showEditAdjustCommentFormDialog}
                noCloseBtn={false}
                onHide={resetForms}
                size={'lg'}
                body={renderEditAdjustCommentForm}
            />

            <ConfirmDialog
                dialogId='toggleStockAdjustConfirmDialog'
                showDialog={!!targetToggleAdjustProduct}
                body={`Are you sure this product is ${targetToggleAdjustProduct?.stockAdjustedFlag === true ? "not adjusted" : "adjusted"}?`}
                onConfirm={handleToggleStockAdjustedFlag}
                onCancel={() => setTargetToggleAdjustProduct(null)}
            />

            <ConfirmDialog
                dialogId='clearAdjustCommentConfirmDialog'
                showDialog={showClearAdjustCommentConfirmDialog}
                body={`Are you sure to clear this Adjust Comment?`}
                onConfirm={(e) => handleEditOrClearAdjustComment(true)}
                onCancel={() => resetForms()}
            />

            <AlertDialog
                dialogId={'successDialog'}
                showDialog={!!successDialogMessage}
                body={successDialogMessage}
                onConfirm={handleSuccessDialogClose}
            />
        </div>
    );
};

export default InstockAdjustmentList;